import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/help/")({
	beforeLoad: () => {
		throw redirect({ to: "/help/faq" });
	},
});
